import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Photos: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 43.45 31.4">
            <g>
                <polygon fill={color} points="43.45 4.59 32.39 4.59 27.65 0 15.66 0 10.93 4.73 0 4.73 0 28.86 1.86 27.1 1.86 6.6 11.7 6.6 16.43 1.86 26.9 1.86 31.64 6.45 41.58 6.45 41.58 29.54 2 29.54 .02 31.4 43.45 31.4 43.45 4.59"/>
                <path fill={color} d="M22.08,27.47c5.16,0,9.36-4.2,9.36-9.36s-4.2-9.36-9.36-9.36-9.36,4.2-9.36,9.36,4.2,9.36,9.36,9.36ZM22.08,10.62c4.13,0,7.5,3.36,7.5,7.5s-3.36,7.5-7.5,7.5-7.5-3.36-7.5-7.5,3.36-7.5,7.5-7.5Z"/>
                <path fill={color} d="M22.08,23.63c3.04,0,5.52-2.48,5.52-5.52s-2.48-5.52-5.52-5.52-5.52,2.48-5.52,5.52,2.48,5.52,5.52,5.52ZM22.08,14.46c2.02,0,3.66,1.64,3.66,3.66s-1.64,3.66-3.66,3.66-3.66-1.64-3.66-3.66,1.64-3.66,3.66-3.66Z"/>
                <rect fill={color} x="17.72" y="4.28" width="8.02" height="1.86"/>
            </g>
        </svg>
    );
};

export default Photos;
